import { css, keyframes } from "@emotion/css";

const opacityGrow = keyframes`
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
`;

export const fadeIn = css`
    animation: ${opacityGrow} 0.4s;
`;

export const activeScaleOut = css`
    transition: all 170ms ease-in-out;

    :active {
        transform: scale(0.9);
    }
`;
